import HTTP_LOGIN from './axios-config-login'
import Router from '../router/index'
import Store from '../store'
import axios from 'axios'

/* eslint-disable no-undef */
const HTTP = axios.create({
  // baseURL: (localStorage.getItem('isOnPremise') === 'yes' && process.env.NODE_ENV !== 'development' ? location.protocol + '//' + location.host : location.protocol + '//' + process.env.BASE_URL_WS_ERP),
  baseURL: (localStorage.getItem('isOnPremise') === 'yes' && process.env.NODE_ENV !== 'development' ? 'https://' + location.host : 'https://' + process.env.BASE_URL_WS_ERP),
  headers: {
    'Content-Type': 'application/json'
  }
})
// Si es on premise, la url es la misma en la que está desplegada la aplicación. DDOL hace la "redirección"
// Por si queremos hacer algo antes de ejecutar el request.
HTTP.interceptors.request.use(function (config) {
  let urlConfig = config.url

  if (localStorage.getItem('isOnPremise') === 'yes') {
    config.headers.common['x-ddol-security-key'] = localStorage.getItem('ddolSecurityKey')
    config.headers.common['x-ddol-org'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).organizacion : null
    config.headers.common['x-ddol-user'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).usuario : null
    config.headers.common['x-ddol-apporg'] = process.env.APPLICATION
    config.headers.common['x-ddol-appdst'] = process.env.APPLICATION_ERP
  }
  if (!['/wscomun/procExpert/login', '/wsr/auth/validateuser'].some(route => urlConfig.includes(route))) {
    config.headers.common['x-ddol-security-token'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).tira : null
    if (config.data) {
      if (!config.data.tira && (localStorage.getItem('datos-autenticacion') && JSON.parse(localStorage.getItem('datos-autenticacion')).tira)) {
        config.data.tira = JSON.parse(localStorage.getItem('datos-autenticacion')).tira
      }
      if (!localStorage.getItem('isOnPremise') === 'yes' && urlConfig !== '/wscomun/portalinformes/lovEmpresa' && !config.data.empresa && (localStorage.getItem('datos-autenticacion') && JSON.parse(localStorage.getItem('datos-autenticacion')).empresa)) {
        config.data.empresa = JSON.parse(localStorage.getItem('datos-portal')).empresa
      } else if (urlConfig !== '/wscomun/portalinformes/lovEmpresa' && !config.data.empresa) {
        config.data.empresa = JSON.parse(localStorage.getItem('datos-autenticacion')).empresa
      }
    }
  }

  return config
}, function (error) {
  console.log(error)
  return Promise.reject(error)
})

HTTP.interceptors.response.use(function (response) {
  let request = response.config
  if (response.data.errorCode && response.data.errorCode !== 0) {
    request.headers['x-ddol-error'] = response.data.errorCode + ' - ' + response.data.errorMsg.substring(0, 130)
  }
  response.config = request
  return response
}, function (error) {
  let request = error.config
  if (error.response.status === 401) {
    return getRefreshToken().then((result) => {
      request.headers['x-ddol-security-token'] = result
      let datosObj = JSON.parse(request.data)
      datosObj.tira = result
      request.data = JSON.stringify(datosObj)
      return axios.request(request)
    }).catch(error => {
      console.log('error token refresh5')
      Store.commit('removeAutenticacion')
      Router.push('/')
      Promise.reject(error)
    })
  } else {
    if (error.response.data.statusCode && error.response.data.statusCode !== '200' && error.response.data.statusText !== undefined && error.response.data.statusText !== '') {
      error.config.headers['x-ddol-error'] = error.response.data.statusCode + ' - ' + error.response.data.statusText.substring(0, 130)
      error.response.headers['x-ddol-error'] = error.response.data.statusCode + ' - ' + error.response.data.statusText.substring(0, 130)
      error.response.config.headers['x-ddol-error'] = error.response.data.statusCode + ' - ' + error.response.data.statusText.substring(0, 130)
    }
    return Promise.reject(error)
  }
})

async function getRefreshToken() {
  const datosPortal = JSON.parse(localStorage.getItem('datos-portal'))
  const payload = {
    orgId: datosPortal.orgId,
    userId: datosPortal.userId,
    refreshTokenId: localStorage.getItem('refreshToken') // esgaAuth.refreshTokenId
  }
  return HTTP_LOGIN.post('/wsr/Auth/tokenRefreshGetAuth', payload).then(response => {
    let datosAuth = JSON.parse(localStorage.getItem('datos-autenticacion'))
    let datosAuthPortal = JSON.parse(localStorage.getItem('datos-portal'))
    // 
    datosAuth.tira = response.data
    datosAuthPortal.tira = response.data
    // 
    localStorage.setItem('datos-autenticacion', JSON.stringify(datosAuth))
    localStorage.setItem('datos-portal', JSON.stringify(datosAuthPortal))
    // 
    return response.data
  }).catch(error => {
    console.log('error token refresh6')
    Promise.reject(error)
  })
}
export default HTTP



// WEBPACK FOOTER //
// ./src/config/axios-config-erp.js